// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610230023/js/" + chunkId + "." + {"44":"c4e9804f","225":"12089006","481":"25a2e88a","486":"d0ac30e9","770":"b2d7020c"}[chunkId] + ".0.8021559485992986.chunk.js";
};